import { searchEntities } from '../../store/selectors/search';

export const selectSuiteUsers = state => searchEntities(state, 'suiteUsers', ['email', 'firstname', 'lastname', 'contactType']);
